import { useEffect, useState } from 'react';

import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { CheckBox } from 'react-native-elements';
import { appTheme } from '@/config/colors';
const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  checkBoxContainerStyle: {
    borderWidth: 0,
    padding: 0,
  },
});

function CustomCheckBox({
  label,
  onChecked,
  disabled,
  checkedColor,
  checked,
  isLabelComponent,
}) {
  const [check, setCheck] = useState(false);

  const onSetCheck = () => {
    setCheck(!check);
    onChecked(check);
  };

  useEffect(() => {
    setCheck(checked);
  }, [checked]);
  return (
    <View style={styles.wrapper}>
      <CheckBox
        containerStyle={styles.checkBoxContainerStyle}
        checked={check}
        onPress={() => onSetCheck()}
        checkedColor={checkedColor || appTheme.primary}
        disabled={disabled || false}
        size={
          Platform.OS === 'web'
            ? useResponsiveFontSize(2)
            : useResponsiveFontSize(3)
        }
      />
      {isLabelComponent ? label : <Text>{label}</Text>}
    </View>
  );
}

export default CustomCheckBox;
